__webpack_require__.p = "/sample-pricing-calculator-for-keyspaces/";